/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function e(e,n){const r=n.debugRendererInfo&&e.getExtension("WEBGL_debug_renderer_info");return r?{getUnmaskedRendererWebGL:()=>e.getParameter(r.UNMASKED_RENDERER_WEBGL)}:null}export{e as loadDebugRendererInfo};
